import { render, staticRenderFns } from "./PolicySubmenu.vue?vue&type=template&id=773e0ffa"
import script from "./PolicySubmenu.vue?vue&type=script&lang=js"
export * from "./PolicySubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports